var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41912 4.33341H5.5C3.29086 4.33341 1.5 6.12428 1.5 8.33341V16.3334C1.5 18.5426 3.29086 20.3334 5.5 20.3334H21.5C23.7091 20.3334 25.5 18.5426 25.5 16.3334V8.33341C25.5 6.12428 23.7091 4.33341 21.5 4.33341H20.5809C20.3157 4.33341 20.0613 4.22806 19.8738 4.04052L18.0858 2.25253C17.7107 1.87746 17.202 1.66675 16.6716 1.66675H10.3284C9.79799 1.66675 9.28929 1.87746 8.91421 2.25253L7.12623 4.04052C6.93869 4.22806 6.68434 4.33341 6.41912 4.33341Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.3335C9.5 14.5426 11.2909 16.3335 13.5 16.3335C15.7091 16.3335 17.5 14.5426 17.5 12.3335C17.5 10.1244 15.7091 8.3335 13.5 8.3335C11.2909 8.3335 9.5 10.1244 9.5 12.3335Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCamera);
export default __webpack_public_path__ + "static/media/photo_camera.6de2533965bb8745ad5fedb0ec4ed4b2.svg";
export { ForwardRef as ReactComponent };